import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AbilityService } from './ability/ability.service';
import { AppSocketService } from './websocket.service';

@Injectable({
  providedIn: 'root',
})
export class ServerNotificationService {
  private testNotificationSubject = new Subject<any>();
  private userNotificationSubject = new Subject<any>();

  constructor(
    private socketService: AppSocketService,
    private abilityService: AbilityService,
  ) {
    this.initializeSocket();
  }

  private initializeSocket() {
    this.socketService.on('TEST_NOTIFICATION', (data) => {
      console.log('Received TEST_NOTIFICATION in ServerNotificationService:', data);
      this.testNotificationSubject.next(data);
    });
    const channel = `USER_COMMAND`;
    this.socketService.on(channel, (data) => {
      console.log(`Received ${channel} ServerNotificationService`, data);
      this.userNotificationSubject.next(data);
    });
  }

  getTestNotifications(): Observable<any> {
    return this.testNotificationSubject.asObservable();
  }
  getUserNotifications(): Observable<any> {
    return this.userNotificationSubject.asObservable();
  }
}
